module.exports = __webpack_public_path__ + "static/garda_main_3-acc0fcaef0e3e86c183c951d46a0b317.png";